import classNames from "classnames";
import React from "react";
import BranchLink from "web/react/components/branch-link/branch-link";
import { gettext } from "web/script/modules/django-i18n";
import { DesktopCampaignRawBranchLink, RawBranchLink } from "web/script/utils/branch-io";
import AppStoreBlack from "img/ui/app-store-black.svg?inline";
import AppStoreWhite from "img/ui/app-store-white.svg?inline";
import Button from "web/react/components/button/button";

import styles from "./app-download-badge.css";

type AppButtonType = "white" | "black";
type AppDownloadLink = "footer" | "appPage" | "appTeaser" | "desktopAppBannerFeeds";

const APP_DOWNLOAD_LINKS: {
    readonly [lnk in AppDownloadLink]: RawBranchLink | DesktopCampaignRawBranchLink;
} = {
    footer: RawBranchLink.Footer,
    appPage: RawBranchLink.AppPage,
    appTeaser: RawBranchLink.AppTeaser,
    desktopAppBannerFeeds: DesktopCampaignRawBranchLink.Feed,
};

interface AppDownloadButtonProps {
    color: AppButtonType;
    appDownloadLink: AppDownloadLink;
    eventLabel: string;
    titleId?: string;
    isBadge?: boolean;
    small?: boolean;
    isButton?: boolean;
    buttonText?: string;
}

export function AppDownloadBadge({
    color,
    small,
    appDownloadLink,
    eventLabel,
    titleId,
    isButton,
    buttonText = "",
}: AppDownloadButtonProps): JSX.Element {
    let title = "";
    if (titleId) {
        title = gettext(titleId);
    }
    const branchLink = APP_DOWNLOAD_LINKS[appDownloadLink];
    const svgProps = { viewBox: "0 0 120 40" };

    return (
        <BranchLink
            className={classNames(styles.badge, {
                [styles.small]: small,
                [styles.buttonSize]: isButton,
            })}
            branchLink={branchLink}
            eventLabel={eventLabel}
            title={title}
        >
            <span>
                {isButton && (
                    <Button styleType="cta" className={styles.downloadButton}>
                        {buttonText}
                    </Button>
                )}
                {!isButton &&
                    (color === "black" ? (
                        <AppStoreBlack {...svgProps} />
                    ) : (
                        <AppStoreWhite {...svgProps} />
                    ))}
            </span>
        </BranchLink>
    );
}

export default AppDownloadBadge;
